import { filterDOMProps } from '@react-aria/utils';
import type { DOMProps } from '@react-types/shared';
import { forwardRef } from 'react';

import type { UnsafeStyleProps } from '@infinex/ui-styles';
import { cn } from '@infinex/ui-styles';

export type SkeletonProps = {
  /**
   * Compose layouts representing your content, with components `SkeletonText`,
   * `SkeletonParagraph`, and `SkeletonMedia`.
   */
  children?: React.ReactNode;
} & DOMProps &
  UnsafeStyleProps;

/**
 * Display a placeholder of your content before data is loaded to indicate
 * that something is happening and preview the content that will appear.
 *
 * [Taurus docs: `Skeleton`](https://ui-sb.app.infinex.dev/?path=/docs/components-skeleton--docs)
 */
export const Skeleton = forwardRef<HTMLDivElement, SkeletonProps>(
  function Skeleton(props, ref) {
    const { children, className, style, ...otherProps } = props;
    return (
      <div
        className={cn('animate-pulse', className)}
        ref={ref}
        style={style}
        {...filterDOMProps(otherProps)}
      >
        <span className="sr-only">Loading…</span>
        {children}
      </div>
    );
  }
);
